import { WHY_US } from "../lib/data";

export default function WhyChooseUs() {
  return (
    <section data-testid="why-choose-us" className="py-24 lg:py-32 bg-navy-deep text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-noise" />
      <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-safety/20 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-navy-light/30 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="kicker !text-safety">Why Choose Insafe</div>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-black text-white tracking-tight leading-tight">
              The trusted safety partner for India{`\u2019`}s most demanding industries.
            </h2>
          </div>
          <p className="lg:col-span-5 text-steel text-lg leading-relaxed">
            We don{`\u2019`}t deliver reports — we deliver outcomes. Every engagement is backed by
            technical depth, legal clarity and a relentless focus on operational reality.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {WHY_US.map((w, i) => {
            const Icon = w.icon;
            return (
              <div
                key={w.title}
                data-testid={`why-card-${i}`}
                className="bg-navy-deep p-8 hover:bg-navy transition-colors group"
              >
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-lg border border-safety/40 text-safety flex items-center justify-center flex-shrink-0 group-hover:bg-safety group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-white leading-tight">{w.title}</h3>
                    <p className="mt-2 text-steel text-[15px] leading-relaxed">{w.desc}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
